import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import KSAGRF from '../assets/images/KSA-GRF.png';//KSA-GRF.png

//



function KSAGRF17() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('KSA_GRF')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}>{t('KSA_GRF_def')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('KSA_GRF_def_sub1')}</li>
          <li style={{ textAlign: 'justify' }}>{t('KSA_GRF_def_sub2')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GRF_sub1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GRF_sub2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_GRF_sub3')}
          <a href={t('SANSRS_Technical_Summary_URL')} download> 
                  {t('sansrs_def1_sub6_link')}
                </a>
           </p>
          
          
          <img src={KSAGRF} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} /></div>
          <br />          
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    <section class="services"style={{gap:"6rem", padding:"1rem"}}>
    <p style={{ textAlign: 'justify' }}>{t('tools')}<Link to="https://gds.geoportal.sa/grf17" target='balnk'>{t('onlineGRFTT')}</Link><br></br><br></br><Link to="/Geodesy/Sansrs/KSAGRF17/FAQ">{t('faq_title')}</Link></p>
      
    </section>
    </div>
);
}

export default KSAGRF17;
